








































































import Vue from 'vue';
import { Route } from 'vue-router';
import PracticeListing from '@/components/PracticeListing.vue';
import UserIcon from '@/components/UserIcon.vue';

export default Vue.extend({
  name: 'Teacher',
  components: {
    PracticeListing,
    UserIcon,
  },
  data() {
    return {
      teacherId: Number,
      teacherData: null,
    };
  },
  created() {
    // Reassign this scope for callback usage
    const component = this;

    // Need to identify the user before fetching their data
    fetch(`https://api.pocketyoga.com/identify/profile/${this.$route.params.teacher}`, {
      headers: { version: '5' },
    })
      .then((response) => {
        if (!response.ok) {
          throw response;
        }

        return response.json();
      })
      .then((json) => {
        component.teacherId = json.id;
        component.fetchData();
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    fetchData() {
      // Reassign this scope for callback usage
      const component = this;

      fetch(`https://api.pocketyoga.com/profiles/${this.teacherId}`, {
        headers: { version: '5' },
      })
        .then((response) => {
          if (!response.ok) {
            throw response;
          }

          return response.json();
        })
        .then((json) => {
          component.teacherData = json;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
});
